(function () {
  'use strict';
  function init(root) {
    if (root.dataset.modelReady) return;
    const compact = root.hasAttribute('data-model-compact');
    const cards = Array.from(root.querySelectorAll('[data-model-choice]'));
    cards.forEach(card => {
      const size = card.dataset.size || '';
      const title = (card.dataset.fullTitle || '').normalize('NFKC');
      const measures = title.match(/\d+(?:[.,]\d+)?\s*(?:インチ|inch|号|LINK|mm|cm)/gi) || [];
      // 2026-10-25 (Yukie): the stored size alone (a ring shows 7号, not 7号 / 6mm); sizes read from the
      // title are only a fallback for items with no stored size, e.g. a chain length.
      const specs = [...new Set((size.trim() ? [size] : measures).filter(Boolean).map(v => v.replace(/インチ/gi, 'inch').replace(/\s+/g, '')))];
      const rank = (card.dataset.rank || '').trim();
      const rankLabel = ['N','S','A','B','C','D'].includes(rank) ? 'ランク' + rank : '';
      card.querySelector('[data-model-spec]').textContent = compact ? [rankLabel, size.trim()].filter(Boolean).join('｜') : specs.join(' / ');
      // A size read from the title brings back the label row the server hid for a group with no stored sizes.
      if (!compact && specs.length) root.removeAttribute('data-model-no-label');
      const wish = card.querySelector('.sf-wishlist__button');
      if (wish) {
        const syncWish = () => { const active = wish.classList.contains('added-to-wishlist'); wish.setAttribute('aria-pressed', String(active)); wish.setAttribute('aria-label', active ? 'お気に入りから削除' : 'お気に入りに追加'); };
        syncWish(); new MutationObserver(syncWish).observe(wish, {attributes:true, attributeFilter:['class']});
      }
      const form = card.querySelector('product-form'), add = card.querySelector('[name="add"]');
      if (form && add) {
        const syncAdd = () => { const busy = form.classList.contains('adding'); add.disabled = busy; add.setAttribute('aria-busy', String(busy)); };
        syncAdd(); new MutationObserver(syncAdd).observe(form, {attributes:true, attributeFilter:['class']});
      }
    });
    if (compact) {
      root.dataset.modelReady = 'true';
      if (!cards.length) { root.hidden = true; return; }
      root.querySelector('[data-model-count]').textContent = cards.length + '点';
      // New arrivals follow storefront publication, not admin creation time.
      const grid = root.querySelector('[data-model-grid]');
      cards.sort((a,b) => Number(b.dataset.published || 0) - Number(a.dataset.published || 0));
      cards.forEach(card => grid.append(card));
      grid.scrollLeft = 0;
      cards.forEach(card => {
        card.hidden = false;
        const article = card.querySelector('article');
        const link = card.querySelector('.corner-model__image');
        article.addEventListener('click', event => {
          if (event.defaultPrevented || event.target.closest('a,button,input,select,form,product-form') || String(window.getSelection())) return;
          window.location.assign(link.href);
        });
      });
      return;
    }
    const color = root.querySelector('[data-model-color]');
    const size = root.querySelector('[data-model-size]');
    const count = root.querySelector('[data-model-count]');
    const controls = root.querySelector('[data-model-filters]');
    if (!cards.length || !color || !size || !count || !controls) return;
    root.dataset.modelReady = 'true';
    const allPage = root.hasAttribute('data-model-all');
    const sort = root.querySelector('[data-model-sort]');
    const dialog = root.querySelector('[data-model-dialog]');
    const filterOpen = root.querySelector('[data-model-filter-open]');
    if (dialog && filterOpen) {
      filterOpen.addEventListener('click', () => dialog.showModal());
      root.querySelector('[data-model-filter-close]').addEventListener('click', () => dialog.close());
      root.querySelector('[data-model-filter-apply]').addEventListener('click', () => dialog.close());
      root.querySelector('[data-model-filter-reset]').addEventListener('click', () => { color.value=''; size.value=''; updateSizes(); render(); });
      dialog.addEventListener('click', e => { if(e.target===dialog) { const r=dialog.getBoundingClientRect(); if(e.clientX<r.left || e.clientX>r.right || e.clientY<r.top || e.clientY>r.bottom) dialog.close(); } });
      sort.addEventListener('change', render);
    }

    const mobile = window.matchMedia('(max-width: 767px)');
    const normalize = v => (v || '').normalize('NFKC').replace(/インチ/gi, 'inch').replace(/\s+/g, '').toUpperCase();
    // A missing colour and the group's only known colour are not separate choices.
    const colors = new Set([root.dataset.currentColor, ...cards.map(c => c.dataset.color)].map(normalize).filter(Boolean));
    const useColor = colors.size > 1;
    const current = {rank: normalize(root.dataset.currentRank), size: normalize(root.dataset.currentSize), color: normalize(root.dataset.currentColor)};
    const choice = c => ({rank: normalize(c.dataset.rank), size: normalize(c.dataset.size), color: useColor ? normalize(c.dataset.color || root.dataset.currentColor) : ''});
    const key = v => JSON.stringify([v.rank, v.size, useColor ? v.color : '']);
    const currentKey = key(current);
    const rankOrder = ['N', 'S', 'A', 'B', 'C', 'D'];
    function distinctChoices(matches) {
      const seen = new Set([currentKey]);
      const options = matches.filter(c => key(choice(c)) !== currentKey).sort((a,b) => {
        const x=choice(a), y=choice(b);
        const priority = v => v.size === current.size ? 0 : v.rank === current.rank ? 1 : 2;
        const rank = v => rankOrder.indexOf(v.rank) < 0 ? 99 : rankOrder.indexOf(v.rank);
        return priority(x)-priority(y) || compareSize(x.size,y.size) || rank(x)-rank(y);
      });
      return options.filter(c => { const k=key(choice(c)); if(seen.has(k)) return false; seen.add(k); return true; });
    }

    const sizeOrder = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', 'XXXL', 'ONE'];
    function compareSize(a, b) {
      const an = parseFloat(a), bn = parseFloat(b);
      if (Number.isFinite(an) && Number.isFinite(bn)) return an - bn;
      const ai = sizeOrder.indexOf(a.toUpperCase()), bi = sizeOrder.indexOf(b.toUpperCase());
      if (ai >= 0 && bi >= 0) return ai - bi;
      return a.localeCompare(b, 'ja', {numeric: true});
    }
    function options(select, values, compare) {
      const previous = select.value;
      const unique = Array.from(new Set(values.filter(Boolean))).sort(compare);
      select.replaceChildren(new Option('すべて', ''));
      unique.forEach(value => select.add(new Option(value, value)));
      if (unique.includes(previous)) select.value = previous;
      return unique.length;
    }
    const colorCount = options(color, cards.map(card => card.dataset.color));
    root.querySelector('[data-color-control]').hidden = colorCount < 2;
    function updateSizes() {
      const pool = cards.filter(card => !color.value || card.dataset.color === color.value);
      const sizeCount = options(size, pool.map(card => card.dataset.size), compareSize);
      root.querySelector('[data-size-control]').hidden = sizeCount < 2;
      if (sizeCount < 2) size.value = '';
      controls.hidden = colorCount < 2 && sizeCount < 2;
      if (filterOpen) filterOpen.disabled = controls.hidden;
    }
    function render() {
      const matches = cards.filter(card => (!color.value || card.dataset.color === color.value) && (!size.value || card.dataset.size === size.value));
      if (allPage && sort) matches.sort((a,b) => {
        if (sort.value === 'price-asc') return Number(a.dataset.price)-Number(b.dataset.price) || Number(b.dataset.published)-Number(a.dataset.published);
        if (sort.value === 'price-desc') return Number(b.dataset.price)-Number(a.dataset.price) || Number(b.dataset.published)-Number(a.dataset.published);
        return Number(b.dataset.published)-Number(a.dataset.published);
      });
      cards.forEach(card => { card.hidden = true; });
      const distinct = !allPage && mobile.matches ? distinctChoices(matches) : matches;
      // Keep the rail useful when all other stock has the same specifications.
      const preview = distinct.length ? distinct : matches.slice(0, 1);
      const grid = root.querySelector('[data-model-grid]');
      const ordered = [...preview, ...cards.filter(c => !preview.includes(c))];
      ordered.forEach(card => grid.appendChild(card));
      preview.forEach((card, index) => { card.hidden = !allPage && index >= 8; });
      grid.hidden = preview.length === 0;
      count.textContent = matches.length + '点';
      const empty = root.querySelector('[data-model-empty]');
      if (empty) empty.hidden = matches.length > 0;
      const filterLabel = root.querySelector('[data-model-filter-label]');
      if (filterLabel) { const active=Number(!!color.value)+Number(!!size.value); filterLabel.textContent='絞り込み'+(active ? '（'+active+'）' : ''); }

    }
    color.addEventListener('change', function () { updateSizes(); render(); });
    size.addEventListener('change', function () { render(); });
    mobile.addEventListener('change', render);
    updateSizes(); render();
  }
  function scan(scope) { scope.querySelectorAll('[data-corner-model]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); }, {once: true});
  else scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
}());
